import { SummaryCard } from '../../types/EmployeeApplicationUsagePage/employeeApplicationUsage.types';

type Props = {
  cards: SummaryCard[];
};

const UsageSummaryCards = ({
  cards,
}: Props) => {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
      {cards.map((card) => (
        <div
          key={card.title}
          className="
            rounded-[14px]
            border
            border-[#E5E7EB]
            bg-white
            px-4
            py-3
          "
        >
          <p
            className="
              text-[11px]
              font-medium
              text-[#111827]
            "
          >
            {card.title}
          </p>

          <div className="mt-[4px] flex items-end gap-1">
            <h2
              className="
                text-[18px]
                font-bold
                leading-none
                text-[#111827]
              "
            >
              {card.value}
            </h2>
          </div>

          <p
            className="
              mt-[4px]
              text-[10px]
              text-[#667085]
            "
          >
            {card.subtitle}
          </p>
        </div>
      ))}
    </div>
  );
};

export default UsageSummaryCards;